
import { defineComponent, onMounted, ref, watch } from 'vue'
import IconGrid from '@/components/IconGrid.vue'

export default defineComponent({
  components: {
    IconGrid
  },
  setup () {
    const search = ref('')
    const matches = ref([])
    const loading = ref(false)
    const debounceInterval = 300

    let debounceTimer
    const getResults = searchVal => {
      clearTimeout(debounceTimer)

      const interval = (
        debounceInterval * Math.abs(Math.log(1 / search.value.length))
      ) || debounceInterval

      loading.value = true
      debounceTimer = setTimeout(
        async () => {
          const response = await fetch('https://therufa-mdi-api.herokuapp.com/?search=' + searchVal)
          const { data } = await response.json()

          matches.value = data.matches
            .map(entry => ({ name: entry.item[0], path: entry.item[1] }))

          loading.value = false
        }, interval)
    }

    onMounted(() => {
      getResults('home')
    })

    watch(search, () => getResults(search.value))

    return {
      search,
      matches,
      loading
    }
  }
})
